import React from "react";
import { useLocation } from "react-router-dom";
import SignupForm from "../components/signup/SignupForm";

const SignupPage = () => {
	const location = useLocation();
	const queryParams = new URLSearchParams(location.search);
	const leadId = queryParams.get("leadId") || queryParams.get("uid");
	const chain = queryParams.get("chain");
	const coupon =
		queryParams.get("coupon") ||
		queryParams.get("promo") ||
		queryParams.get("discount");
	const type = queryParams.get("type"); // e.g. "payment_update"
	const startDate = queryParams.get("startDate"); // e.g. "12-01-2026" (DD-MM-YYYY)

	// Optional prefill fields (all optional)
	const prefill = {
		firstName: queryParams.get("firstName") || "",
		lastName: queryParams.get("lastName") || "",
		email: queryParams.get("email") || "",
		practiceName: queryParams.get("practiceName") || "",
		address: queryParams.get("address") || "",
		city: queryParams.get("city") || "",
		postalCode: queryParams.get("postalCode") || "",
		country: queryParams.get("country") || "",
	};

	return (
		<>
			<SignupForm
				leadId={leadId}
				chain={chain}
				coupon={coupon}
				type={type}
				startDate={startDate}
				prefill={prefill}
			/>
		</>
	);
};

export default SignupPage;
